var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _expanded, _disableOnDesktop, _collapsedHeight, _disabledClass, _ShowMoreComponent_instances, currentBreakpoint_get, _animation, _animationSpeed, _updateBreakpointState, _expand, _collapse, _animateHeight, onAnimationFinish_fn;
import { Component } from "@theme/component";
import { isMobileBreakpoint } from "@theme/utilities";
class ShowMoreComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ShowMoreComponent_instances);
    __publicField(this, "requiredRefs", ["showMoreButton", "showMoreItems", "showMoreContent"]);
    /**
     * @type {boolean}
     */
    __privateAdd(this, _expanded, false);
    /**
     * @type {boolean}
     */
    __privateAdd(this, _disableOnDesktop, false);
    /**
     * @type {number}
     */
    __privateAdd(this, _collapsedHeight, 0);
    /**
     * @type {'mobile:hidden' | 'hidden'}
     */
    __privateAdd(this, _disabledClass, "hidden");
    /**
     * @type {Animation | undefined}
     */
    __privateAdd(this, _animation);
    /**
     * @constant {number}
     */
    __privateAdd(this, _animationSpeed, 300);
    /**
     * Updates the current breakpoint and apprpropriate disabled class
     */
    __privateAdd(this, _updateBreakpointState, () => {
      __privateSet(this, _disableOnDesktop, this.dataset.disableOnDesktop === "true");
      __privateSet(this, _disabledClass, __privateGet(this, _disableOnDesktop) ? "mobile:hidden" : "hidden");
    });
    /**
     * Handles expanding the content
     * @returns {{startHeight: number, endHeight: number}}
     */
    __privateAdd(this, _expand, () => {
      const { showMoreItems, showMoreContent } = this.refs;
      __privateSet(this, _collapsedHeight, showMoreContent.offsetHeight);
      const startHeight = __privateGet(this, _collapsedHeight);
      showMoreItems?.forEach((item) => item.classList.remove(__privateGet(this, _disabledClass)));
      return {
        startHeight,
        endHeight: showMoreContent.scrollHeight
      };
    });
    /**
     * Handles collapsing the content
     * @returns {{startHeight: number, endHeight: number}}
     */
    __privateAdd(this, _collapse, () => {
      const { showMoreContent } = this.refs;
      const startHeight = showMoreContent.offsetHeight;
      const endHeight = __privateGet(this, _collapsedHeight);
      return { startHeight, endHeight };
    });
    /**
     * Initializes a height transition
     * @param {number} startHeight
     * @param {number} endHeight
     */
    __privateAdd(this, _animateHeight, (startHeight, endHeight) => {
      const { showMoreContent } = this.refs;
      showMoreContent.style.overflow = "hidden";
      __privateGet(this, _animation)?.cancel();
      __privateSet(this, _animation, showMoreContent.animate(
        {
          height: [`${startHeight}px`, `${endHeight}px`]
        },
        {
          duration: __privateGet(this, _animationSpeed),
          easing: "ease-in-out"
        }
      ));
      __privateGet(this, _animation).onfinish = () => __privateMethod(this, _ShowMoreComponent_instances, onAnimationFinish_fn).call(this);
    });
    /**
     * Toggles the expansion state of the content.
     *
     * @param {Event} event - The click event
     */
    __publicField(this, "toggle", (event) => {
      event.preventDefault();
      __privateGet(this, _updateBreakpointState).call(this);
      if (__privateGet(this, _ShowMoreComponent_instances, currentBreakpoint_get) === "DESKTOP" && __privateGet(this, _disableOnDesktop)) return;
      const { startHeight, endHeight } = !__privateGet(this, _expanded) ? __privateGet(this, _expand).call(this) : __privateGet(this, _collapse).call(this);
      this.dataset.expanded = __privateGet(this, _expanded) ? "false" : "true";
      this.refs.showMoreButton.setAttribute("aria-expanded", this.dataset.expanded);
      __privateGet(this, _animateHeight).call(this, startHeight, endHeight);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    __privateGet(this, _updateBreakpointState).call(this);
  }
}
_expanded = new WeakMap();
_disableOnDesktop = new WeakMap();
_collapsedHeight = new WeakMap();
_disabledClass = new WeakMap();
_ShowMoreComponent_instances = new WeakSet();
currentBreakpoint_get = function() {
  return isMobileBreakpoint() ? "MOBILE" : "DESKTOP";
};
_animation = new WeakMap();
_animationSpeed = new WeakMap();
_updateBreakpointState = new WeakMap();
_expand = new WeakMap();
_collapse = new WeakMap();
_animateHeight = new WeakMap();
/**
 * Handles the animation finish event.
 */
onAnimationFinish_fn = function() {
  const { showMoreContent, showMoreItems } = this.refs;
  if (__privateGet(this, _expanded)) {
    showMoreItems.forEach((item) => item.classList.add(__privateGet(this, _disabledClass)));
  }
  showMoreContent.style.removeProperty("height");
  showMoreContent.style.overflow = "";
  __privateSet(this, _expanded, !__privateGet(this, _expanded));
};
if (!customElements.get("show-more-component")) {
  customElements.define("show-more-component", ShowMoreComponent);
}
